import { useLayoutEffect } from 'react';

import { Outlet } from 'react-router-dom';

import { useCoachLayoutContext } from '@/features/coach';

export const CoachInterviewShareLayout = () => {
  const { setNavDisplayed } = useCoachLayoutContext();

  useLayoutEffect(() => {
    setNavDisplayed(false);
  }, [setNavDisplayed]);

  return <Outlet />;
};
